import { cn } from '@/lib/utils/cn';
import type { UploadSlot } from '@/store/uploadStore';
import { invokeSlotAction } from '@/store/uploadStore';
import { SlotRowContent } from './SlotRowContent';

export function SlotRow({
  slot,
  t,
  onRemove,
}: {
  slot: UploadSlot;
  t: (key: string) => string;
  onRemove: () => void;
}) {
  const clickable =
    (slot.hasAction === true || !!slot.metadata?.ctaUrl) &&
    slot.status === 'done';
  const baseClass =
    'flex items-start gap-2.5 px-3 py-2.5 border-b border-border last:border-0';

  if (clickable) {
    return (
      <button
        type='button'
        onClick={() => invokeSlotAction(slot.id)}
        className={cn(
          baseClass,
          'w-full text-left cursor-pointer hover:bg-muted/50 transition-colors',
        )}
      >
        <SlotRowContent slot={slot} t={t} onRemove={onRemove} asDiv />
      </button>
    );
  }

  return (
    <div className={baseClass}>
      <SlotRowContent slot={slot} t={t} onRemove={onRemove} />
    </div>
  );
}
